
import {Component, Vue} from "vue-property-decorator";
import i18n from "../plugins/vue-i18n";
import SidebarEnrichissement from "@/components/enrichissement/SidebarEnrichissement.vue";
import FilesEnrichissement from "@/components/enrichissement/FilesEnrichissement.vue";
import ExportEnrichissement from "@/components/enrichissement/ExportEnrichissement.vue";
import enrichissementService from "../services/enrichissement.service";
import {namespace} from "vuex-class";
import IEnrichissement from '@/types/enrichissement.interface';
import DataEnrichissement from "@/components/enrichissement/DataEnrichissement.vue";
import panierService from "@/services/panier.service";
import preferencesService from "@/services/preferences.service";
import dataService from "@/services/data.service";

const userModule = namespace("userModule");
const panierModule = namespace("panierModule");

@Component({
    components: {
        FilesEnrichissement,
        ExportEnrichissement,
        DataEnrichissement,
        SidebarEnrichissement
    },
})
export default class Enrichissement extends Vue {
    tab = null;
    stepper = 1;
    items = [
        {tab: i18n.tc("enrichissement.tabs.files"), content: "FilesEnrichissement", step: 1},
        {tab: i18n.tc("enrichissement.tabs.data"), content: "DataEnrichissement", step: 2},
        {tab: i18n.tc("enrichissement.tabs.export"), content: "ExportEnrichissement", step: 3},
    ];
    result = {
        nb: 0,
        credits: 0,
    };

    @panierModule.Mutation
    public setItemCat!: (itemCat: string) => void;

    enrichissementFile = null;
    previousFile = null;
    preferenceFile = [];
    dataToAdd = [];
    selectedExportFormat = null;
    previews = [];
    headers = [];
    isLoadingData = false;
    isLoadingPreview = false;
    isSavingPreference = false;
    dialogPreview = false;
    basket = null;
    preferenceName: string = null;
    saveModal = false;
    preferenceTrigger = true;
    modalType = '';
    futureFile = null;
    dataTypes = this.unknownDataTypes();
    setFile = [];
    trueUpload = false;
    snackbar = false;
    snacktext = '';
    saveType = 0;

    created() {
      this.setItemCat("Enrichissement");
        if (this.$route.params.id) {
            panierService.getFileFromId(this.$route.params.id).then((res) => {
                this.basket = res.data.message.basket.Items[0];
                this.enrichment = res.data.message.basket.Items[0].filters;
                // enrichment has only one file
                this.enrichissementFile = this.enrichment.files[0];
                if (this.enrichissementFile.identifiers.type === 'siren') {
                    this.dataTypes = this.companyDataTypes();
                } else if (this.enrichissementFile.identifiers.type === 'siret') {
                    this.dataTypes = this.establishmentDataTypes();
                }
                this.dataToAdd = this.enrichment.datas;
                this.setFile = [this.enrichment.files[0]];
                this.refreshResult();
            });
        }
    }

    resetProduct() {
        if (this.$route.params.id) {
            panierService.getFileFromId(this.$route.params.id).then((res) => {
                this.basket = res.data.message.basket.Items[0];
                this.enrichment = res.data.message.basket.Items[0].filters;
                // enrichment has only one file
                this.enrichissementFile = this.enrichment.files[0];
                if (this.enrichissementFile.identifiers.type === 'siren') {
                    this.dataTypes = this.companyDataTypes();
                } else if (this.enrichissementFile.identifiers.type === 'siret') {
                    this.dataTypes = this.establishmentDataTypes();
                }
                this.setFile = [this.enrichissementFile];
                this.dataToAdd = this.enrichment.datas;
                this.refreshResult();
            });
        } else {
            this.dataTypes = this.unknownDataTypes();
            this.enrichissementFile = null;
            this.dataToAdd = [];
            this.stepper = 1;
            this.preferenceFile = [];
            this.setFile = [this.enrichissementFile];
            this.refreshResult();
        }
    }

    uploadFile(file, oldFile, trueUpload) {
        if (this.dataToAdd.length === 0) {
            this.enrichissementFile = file;
            this.setFile = [this.enrichissementFile];
            if (!this.enrichissementFile || !this.enrichissementFile.identifiers) {
                this.dataTypes = this.unknownDataTypes();
            } else if (this.enrichissementFile.identifiers.type === 'siren') {
                this.dataTypes = this.companyDataTypes();
            } else if (this.enrichissementFile.identifiers.type === 'siret') {
                this.dataTypes = this.establishmentDataTypes();
            }
        } else if (file && (!this.enrichissementFile || file.uuid !== this.enrichissementFile.uuid)) {
            this.trueUpload = trueUpload;
            this.futureFile = file;
            this.previousFile = oldFile;
            this.modalType = 'changeFile';
            this.preferenceName = this.preferenceFile && this.preferenceFile.length > 0 ? this.preferenceFile[0].name : '';
            this.saveModal = true;
            this.snackbar = false;
        } else if (file && file.uuid === this.enrichissementFile.uuid) {
            this.enrichissementFile = JSON.parse(JSON.stringify(file));
            this.setFile = [this.enrichissementFile];
            if (!this.enrichissementFile || !this.enrichissementFile.identifiers) {
                this.dataTypes = this.unknownDataTypes();
            } else if (this.enrichissementFile.identifiers.type === 'siren') {
                this.dataTypes = this.companyDataTypes();
            } else if (this.enrichissementFile.identifiers.type === 'siret') {
                this.dataTypes = this.establishmentDataTypes();
            }
        } else if (!file) {
            this.setFile = [];
            this.enrichissementFile = null;
        }
    }

    uploadPreferenceFile(file) {
        if (file.length > 0) {
            this.preferenceFile = file;
            this.dataToAdd = file[0].datas;
        } else {
            this.dataToAdd = [];
            this.preferenceFile = [];
            this.refreshResult();
        }

    }

    uploadDataToAdd(data) {
        this.dataToAdd = data;
        this.refreshResult();
    }

    uploadFormat(format) {
        this.selectedExportFormat = format;
    }

    removeFile() {
        this.enrichissementFile = null;
    }

    removePreferenceFile() {
        this.preferenceFile = [];
    }

    removeDataToAdd(data) {
        this.dataToAdd = this.dataToAdd.filter(obj => obj !== data);
        this.refreshResult();
    }

    setIdentifier(data) {
        if (data.type !== this.enrichissementFile.identifiers.type) {
            this.trueUpload = false;
            this.futureFile = this.enrichissementFile;
            this.futureFile.identifiers = data;
            this.previousFile = this.enrichissementFile;
            this.modalType = 'changeFile';
            this.preferenceName = this.preferenceFile && this.preferenceFile.length > 0 ? this.preferenceFile[0].name : '';
            this.saveModal = true;
            this.snackbar = false;
        }
    }

    public enrichment: IEnrichissement = {
        datas: [],
        files: [],
        productId: null
    };

    updateEnrichment() {
        this.enrichment.datas = this.dataToAdd;
        this.enrichment.files = [];
        if (this.enrichissementFile) {
            this.enrichment.files.push(this.enrichissementFile);
        }
    }

    @userModule.State
    public user!: any;
    @panierModule.Action
    public addProduct!: () => void;

    createdHeadersFile(items) {
        const headers = [];

        if (items && items.length > 0) {
            for (const key of Object.keys(items[0]).filter(k => k !== 'lineId' && k !== 'fileId')) {
                headers.push({
                    text: items[0][key],
                    value: key
                });
            }
        }
        return headers;
    }

    previewData() {
        this.headers = [];
        this.previews = [];
        this.updateEnrichment();
        this.isLoadingPreview = true;
        enrichissementService.preview(this.enrichment).then((res: any) => {
            this.headers = this.createdHeadersFile(res.data.message);
            const tempPreviews = res.data.message;
            tempPreviews.shift();
            this.previews = tempPreviews;
            this.isLoadingPreview = false;
            this.dialogPreview = true;
        });
    }

    refreshResult() {
        this.updateEnrichment();
        if (this.enrichment.files.length > 0) {
            this.isLoadingData = true;
            enrichissementService
                .getPrice(this.enrichment)
                .then((res) => {
                    this.result = res.data.message;
                    this.isLoadingData = false;
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }

    order(modify: boolean) {
        this.isLoadingData = true;
        this.updateEnrichment();

        const id = Date.now();
        const product = {
            id: id,
            type: "enrichissement",
            segment: this.enrichment.files[0].identifiers.type === 'siret',
            date: new Date().toLocaleString('fr-FR', {timeZone: 'Europe/Paris'}),
            results: this.result.nb,
            credits: this.result.credits,
            format: "csv",
            content: JSON.parse(JSON.stringify({...this.enrichment, ...{productId: id}}))
        };
        this.modalType = 'order';
        this.preferenceName = this.preferenceFile && this.preferenceFile.length > 0 ? this.preferenceFile[0].name : '';
        if (modify) {
            panierService.putBasket(this.basket.basketId, null, product.results, product.credits, product.format, product.segment, product.type, this.user.id, this.basket.basketStatus, this.user.email, product.content).then(res => {
                this.saveModal = true;
                this.isLoadingData = false;
                this.snackbar = false;
            });
        } else {
            panierService.postFile(null, product.results, product.credits, product.format, product.segment, product.type, this.user.id, product.content).then(res => {
                this.addProduct();
                this.saveModal = true;
                this.isLoadingData = false;
                this.snackbar = false;
            });
        }
    }

    savePreferenceFilter(preferenceFile) {
        this.isSavingPreference = true;
        this.updateEnrichment();
        this.saveType =2;

        preferencesService.savePreferenceFilter({
            datas: this.enrichment.datas,
            files: this.enrichment.files,
            name: this.preferenceName,
            uuid: this.preferenceFile && this.preferenceFile.length > 0 ? this.preferenceFile[0].uuid : null,
            id: this.preferenceFile && this.preferenceFile.length > 0 ? this.preferenceFile[0].id : null,
            date: this.preferenceFile && this.preferenceFile.length > 0 ? this.preferenceFile[0].date : null,
        }, this.user.id, 'enrichment').then(() => {
            this.preferenceTrigger = !this.preferenceTrigger;
            this.isSavingPreference = false;
        });
        this.snacktext = preferenceFile === null || preferenceFile.length === 0 ? i18n.tc('preferences_saved') : i18n.tc('preferences_updated');
        this.snackbar = true;
        //this.saveModal = false;
      }

    applyNewFile() {
        this.dataToAdd = [];
        this.preferenceFile = [];
        this.enrichissementFile = JSON.parse(JSON.stringify(this.futureFile));
        this.setFile = [this.enrichissementFile];
        if (this.enrichissementFile.identifiers.type === 'siren') {
            this.dataTypes = this.companyDataTypes();
        } else if (this.enrichissementFile.identifiers.type === 'siret') {
            this.dataTypes = this.establishmentDataTypes();
        }
        this.dataToAdd = [];
        this.futureFile = null;
        this.refreshResult();
    }

    cancelModal() {
        if (this.modalType === 'changeFile') {
            const previous = JSON.parse(JSON.stringify(this.previousFile));
            this.setFile = [previous];
            this.enrichissementFile = previous;
            if (!this.enrichissementFile || !this.enrichissementFile.identifiers) {
                this.dataTypes = this.unknownDataTypes();
            } else if (this.enrichissementFile.identifiers.type === 'siren') {
                this.dataTypes = this.companyDataTypes();
            } else if (this.enrichissementFile.identifiers.type === 'siret') {
                this.dataTypes = this.establishmentDataTypes();
            }
        }
        this.saveModal = false;
        this.snackbar = false;
    }

    unknownDataTypes() {
        const identity = {
            id: 0,
            key: "identity",
            filter: "id",
            name: i18n.tc('enrichissement.data.datas.id')
        };
        return dataService.generateDataTypes(identity, true);
    }

    establishmentDataTypes() {
        return dataService.generateDataTypes(null, false);
    }

    companyDataTypes() {
        const identity = {
            id: 0,
            key: "identity",
            filter: "id_etablissement",
            name: i18n.tc('siret')
        };
        return dataService.generateDataTypes(identity, true);
    }

    previewCss(value) {
        if (value && typeof value === 'string') {
            const words = value.split(' ');
            const longest = words.reduce((a, b) => a.length > b.length ? a : b);
            if (longest.length > 15 || value.length > 25) {
                return 'big-preview-header';
            } else if (longest.length > 10 || value.length > 15) {
                return 'medium-preview-header';
            } else {
                return 'preview-header';
            }
        } else {
            return 'preview-header';
        }
    }

    savePreference(update) {
        this.saveType = 1;
        this.preferenceTrigger = !this.preferenceTrigger;
        this.snacktext = update ? i18n.tc('preferences_edited') : i18n.tc('preferences_saved');
        this.snackbar = true;
    }
}
